import {Component, computed, input, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {I18nModule, EventService} from '@spartacus/core';
import {EddlDownloadAttemptEvent} from '@app/services/analytics/EDDL/events/eddl-download-attempt-event';
import {EddlDownloadSuccessEvent} from '@app/services/analytics/EDDL/events/eddl-download-success-event';
import '@ui5/webcomponents-icons/dist/play.js';
import '@ui5/webcomponents-icons/dist/pdf-attachment.js';
import '@ui5/webcomponents-icons/dist/world.js';

@Component({
    selector: 'dcp-product-type-display',
    templateUrl: './product-type-display.component.html',
    styleUrls: ['./product-type-display.component.scss'],
    standalone: true,
    imports: [I18nModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductTypeDisplayComponent {
  type = input<string | undefined>();
  value = input<string | undefined>();

  isPdf = computed(() => !!this.value()?.includes('.pdf'));

  constructor(private eventService: EventService) {}

  onPdfClick(): void {
    if (!this.isPdf()) return;
    const url = this.value();
    const attempt = new EddlDownloadAttemptEvent();
    attempt.url = url;
    const success = new EddlDownloadSuccessEvent();
    success.url = url;
    setTimeout(() => {
      this.eventService.dispatch(attempt);
      this.eventService.dispatch(success);
    });
  }
}
